import { render } from "./EmergencyModal.vue?vue&type=template&id=6f681283&scoped=true"
import script from "./EmergencyModal.vue?vue&type=script&lang=js"
export * from "./EmergencyModal.vue?vue&type=script&lang=js"

import "./EmergencyModal.vue?vue&type=style&index=0&id=6f681283&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f681283"]])

export default __exports__